import React from 'react';
import LabelLift from "../UI/LabelLift";
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LiftLine from "./components/LiftLine";

const Lift5 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift5"
			 className={getLiftClass(isOpen, activeLiftId === '5', state)}
			 transform="translate(1452.000000, 369.000000)"
		>
			<LiftLine x1="193.73703" y1="196" x2="385" y2="13.1200004" color={colors[0]}/>
			<LiftLine x1="13.5" y1="470.5" x2="90.5" y2="343.5" color={colors[0]}/>
			<LiftLine x1="112.26297" y1="312.88" x2="186.5" y2="204.5" color={colors[0]}/>

			<LiftLabelTypeSeat
				seatCount="4"
				colors={getLiftStatusColors(state, isOpen)}
				isOpen={isOpen}
				coords="123.000000, 256.000000"/>

			<LabelLift coords="0.000000, 457.000000" text="" isOpen={isOpen} state={state}/>

			<polygon
				fill={colors[2]}
				transform="translate(13.682412, 469.682412) scale(-1, 1) rotate(62.000000) translate(-13.682412, -469.682412) "
				points="8.18241236 469.682412 19.1824124 464.182412 16.8109251 469.682412 19.1824124 475.182412"
			/>

			<LabelLift coords="370.000000, 0.000000" text={<tspan x="0.0751953125" y="13">5</tspan>} isOpen={isOpen} state={state}/>
		</g>
	);
};

Lift5.propTypes = {};

export default Lift5;
